<h4 matDialogTitle>Adding {{ item.code }}</h4>
<form (submit)="submit()" #form="ngForm">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="12px">
      <div fxLayout="column">
        <p>Please specify the quantity to be hired for this item.</p>
        <mat-form-field>
          <input
            matInput
            [(ngModel)]="quantity"
            name="Quantity"
            placeholder="Quantity"
            required
            min="1"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="dialogRef.close()" type="button">
      Cancel
    </button>
    <button
      mat-raised-button
      [disabled]="!form.valid"
      color="primary"
      id="add-item"
      type="submit"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
